import {
	Component,
	OnInit,
	OnDestroy,
	HostBinding,
	HostListener,
	ViewChild,
	ElementRef,
} from "@angular/core";
import { Subscription } from "rxjs";
import { PageLoaderService } from "./page-loader.service";
import { PageLoaderState } from "./page-loader.state";
@Component({
	selector: "page-loader-animation",
	templateUrl: "page-loader-animation.directive.html",
	styleUrls: ["page-loader-animation.directive.css"],
})
export class PageLoaderAnimationDirective implements OnInit {
	show = false;
	private subscription: Subscription;
	@ViewChild("loadercon") private loaderContainer: ElementRef;
	@HostBinding("style.height") height: string;
	constructor(private loaderService: PageLoaderService) {
		this.subscription = this.loaderService.loaderState$.subscribe(
			(state: PageLoaderState) => {
				this.show = state.show;
				this.height = "100%";
				if (state.show === false) {
					this.height = "0%";
					this.ngOnDestroy();
				}
			}
		);
	}
	ngOnInit() {}
	ngOnDestroy() {
		// this.subscription.unsubscribe();
		console.log("loader subscription destroy");
	}
}
